import React from 'react';
import botImage from "../../assets/images/chatbot_networkerr.png"; // Your local image

const NetworkErrorModal = ({ isOpen, onRetry, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="network-modal-overlay">
            <div className="network-modal-content">
                
                {/* Robot Image - CSS will make it 120x120px */}
                <img 
                    src={botImage} 
                    alt="Network Error" 
                    className="network-modal-icon" 
                />
                
                <h3 className="network-modal-title">Network Issue</h3>
                
                {/* Exact text from your image */}
                <p className="network-modal-text">
                    Sorry! I am unable to reach you. Your network is slow very low. Try after some time.
                </p>

                {/* Side-by-side Buttons */}
                <div className="network-modal-actions">
                    <button className="modal-btn modal-btn-close" onClick={onClose}>
                        Close
                    </button>
                    <button className="modal-btn modal-btn-retry" onClick={onRetry}>
                        Try again
                    </button>
                </div>

            </div>
        </div>
    );
};

export default NetworkErrorModal;